"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityServices = void 0;
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const Resources_1 = require("../../Resources");
const Card_1 = require("../Card");
const CardRenderer_1 = require("../render/CardRenderer");
class CommunityServices extends Card_1.Card {
    constructor() {
        super({
            cost: 13,
            name: CardName_1.CardName.COMMUNITY_SERVICES,
            cardType: CardType_1.CardType.AUTOMATED,
            metadata: {
                cardNumber: 'C04',
                description: 'Increase your M€ production 1 step per CARD WITH NO TAGS, including this.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => {
                        pb.megacredits(1);
                    }).slash().noTags();
                }),
                victoryPoints: 1,
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, player.getNoTagsCount() + 1, { log: true });
        return undefined;
    }
    getVictoryPoints() {
        return 1;
    }
}
exports.CommunityServices = CommunityServices;
//# sourceMappingURL=CommunityServices.js.map